module.exports = __webpack_public_path__ + "static/media/arrow_left.e0f5c58b.svg";